import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { CalendarVO } from '@/service-proxies/app-v2/time.service-proxies'
import { actions } from '../store'
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
const crsp = new CodeRuleServiceProxy();
@Component
export default class InfoForm extends Vue {
  @Prop({ default: () => null }) data: CalendarVO
  @Prop({ default: () => false }) visable: boolean

  body = {
    id: '',
    code: '',
    name: '',
    year: 0,
    status: true,
    codeRuleId: ''
  }
  codeList=[]
  codeId=false
  thisYear = dayjs().year()

  get isUpdate() {
    return !!this.data
  }

  @Watch('body.year')
  changeYear(year: number) {
    // this.emitYearChange(year)
    actions.setYear(year)
  }

  @Watch('visable')
  changeCodeId(val) {
    if(val === true){
      this.codeId = false
    }
  }

  @Emit('yearChange')
  emitYearChange(year: number) {
    return year
  }

  @Emit('codeChange')
  emitCodeChange(codeRuleId: string) {
    return codeRuleId
  }

  created() {
    if (this.data) {
      this.body = {
        codeRuleId: this.body.codeRuleId,
        id: this.data.id,
        code: this.data.code,
        name: this.data.name,
        year: this.data.year,
        status: this.data.status === 0 ? false : true,
      }
    } else {
      this.body.year = this.thisYear
    }
    this.getList()
  }

  async getList() {
    let result = await crsp.list("ProductionTimeObject")
    this.codeList = result.map(item =>({label:item.name,value:item.id}))      
  }
  handleChangeCode (val) {
    if(val){
      this.body.code = ""
      this.codeId = true
    }else{
      this.codeId = false
    }
  }
  filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    }

  render() {
    return (
      <a-form layout="inline">
        <a-form-item label={this.$t('page_system_coding_rules')} v-show={this.visable}>
        <a-select  
        show-search
        filter-option={this.filterOption}
        v-model={this.body.codeRuleId} style="width: 174px" onChange={value =>this.handleChangeCode(value)} allowClear={true} placeholder={this.$t('please_select') as string + this.$t('page_system_coding_rules')}>
         { this.codeList.map(item => {
                return <a-select-option value={ item.value }>
                        { item.label }
                      </a-select-option>
              })}
          </a-select>
        </a-form-item>
        <a-form-item label={this.$t('page_calendar_c_code')} required={!this.codeId}>
          <a-input v-model={this.body.code} disabled={this.visable?this.codeId:this.isUpdate} placeholder={this.$t('please_select') as string  + this.$t('page_calendar_c_code')}/>
        </a-form-item>
        <a-form-item label={this.$t('page_calendar_c_name')} required >
          <a-input v-model={this.body.name} placeholder={this.$t('common_please_input') as string  + this.$t('page_calendar_c_name')}/>
        </a-form-item>
        <a-form-item label={this.$t('page_calendar_use_year')}>
          <a-select 
          show-search
          filter-option={this.filterOption}
          v-model={this.body.year} style="width: 174px" disabled={this.isUpdate} placeholder={this.$t('please_select') as string  + this.$t('page_calendar_use_year')}>
            {Array(9)
              .fill('')
              .map((_, index) => {
                const v = index + this.thisYear - 4
                return <a-select-option value={v}>{v}</a-select-option>
              })}
          </a-select>
        </a-form-item>
      </a-form>
    )
  }
}
